import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import AddPortfolio from "./AddPortfolio";
import {
  deletePortfolio,
  getPortfolio,
  getPortfoliobyId,
} from "../../../redux/profile/action";
import PostNotFound from "../../CustomComponents/AllLoader/PostNotFound";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import ImageWithFallback from "../../../common/ImageWithFallback";
import DisplayFileProper from "../../Common/FilesRelevent/DisplayFileProper";
import ConfirmModal from "../../Common/ConfirmModal";
import { decodeHtml } from "../../../assests/extention/commonfunction";

export default function ManagePortfolio() {
  const [work_sample, setWork_sample] = useState({
    title: "",
    url: "",
    description: "",
    skills: [],
    files: [],
    type: "portfolio",
  });
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(0);

  // Delete confirmation state
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const porpoliolistings = useSelector(
    ({ profile: { porpoliolistings } }) => porpoliolistings
  );

  const modalStyle = {
    right: modalOpen ? "0" : "-100%",
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPortfolio());
    LoadCSSforfirstTime("Assets/scss/myorders.module.scss");
  }, [dispatch]);

  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modalOpen]);

  const movetodetails11 = (item) => {
    navigate(`/${lan}/worksample/${item?.id}`);
  };

  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setDeleteModalOpen(true);
  };

  const confirmDelete = useCallback(() => {
    if (itemToDelete) {
      dispatch(deletePortfolio(itemToDelete.id));
      setDeleteModalOpen(false);
      setItemToDelete(null);
    }
  }, [dispatch, itemToDelete]);

  const porpoliobyid = useSelector(
    ({ profile: { porpoliobyid } }) => porpoliobyid
  );
  const update = (item) => {
    const updatedData = {
      ...item,
      skills: item.skills.map(({ skill_id, ...rest }) => ({
        id: skill_id,
        ...rest,
      })),
    };
    setSelectedItemId(item.id);
    setWork_sample(updatedData);
    setModalOpen(true);
  };

  useEffect(() => {
    if (selectedItemId) {
      dispatch(getPortfoliobyId(selectedItemId));
    }
  }, [selectedItemId]);

  useEffect(() => {
    if (porpoliobyid && Object.entries(porpoliobyid).length !== 0) {
      setWork_sample((prev) => JSON.stringify(prev) !== JSON.stringify(porpoliobyid) ? porpoliobyid : prev);
    }
  }, [porpoliobyid]);

  return (
    <>
      <div className="manageportfolio">
        <p onClick={() => navigate(`/${lan}/createpost`)}></p>
        <div className="portfolio-first">
          <div>
            <h4 className="font-42">My work samples</h4>
            <p>Showcase your work and improve your chance to get hired</p>
          </div>
          <button
            onClick={() => {
              setModalOpen(true);
              setSelectedItemId(0);
              setWork_sample({
                title: "",
                url: "",
                description: "",
                skills: [],
                files: [],
                type: "portfolio",
              });
            }}
            className="buttons border-button"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
              alt=""
            />
            Add Work
          </button>
        </div>
        {Array.isArray(porpoliolistings?.work_sample) &&
          porpoliolistings?.work_sample?.length > 0 ? (
          <div className="row portfolio-row">
            {porpoliolistings?.work_sample?.map((item, index) => (
              <div className="col-md-4" key={item?.id}>
                <div className="manage-image manage-height manage-height-img-sec">
                  <div className="edit-delete-public">
                    <button onClick={() => handleDeleteClick(item)}>
                      {" "}
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/delete-icon.svg`}
                        alt=""
                      />{" "}
                    </button>
                    <button onClick={() => update(item)}>
                      {" "}
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />{" "}
                    </button>
                  </div>
                  {Array.isArray(item?.files) && item?.files[0] && (
                    <span
                      onClick={() => movetodetails11(item)}
                    >
                      <DisplayFileProper
                        className="w-100"
                        item={{ file: item?.files[0]?.file }}
                      />
                    </span>
                  )}
                  <p>{decodeHtml(item.title)}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <PostNotFound title={"No Work samples "} />
        )}
      </div>

      <ConfirmModal
        isOpen={deleteModalOpen}
        toggle={() => setDeleteModalOpen(!deleteModalOpen)}
        title="Delete Work Sample"
        message={`Are you sure you want to delete "${decodeHtml(itemToDelete?.title)}"?`}
        onConfirm={confirmDelete}
        onCancel={() => setItemToDelete(null)}
        confirmText="Delete"
        cancelText="Cancel"
      />


      <div
        className={
          modalOpen ? `add-education-modal  active` : "add-education-modal "
        }
        style={modalStyle}
        isOpen={modalOpen}
      >
        <h4>Work Sample</h4>
        <button
          onClick={() => {
            setModalOpen(false);
          }}
          className="btn close-modal-btn ml-auto d-block"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
            alt=""
          />
        </button>
        <AddPortfolio
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          work_sample={work_sample}
          setWork_sample={setWork_sample}
          selectedItemId={selectedItemId}
          setSelectedItemId={setSelectedItemId}
          setActiveTab={() => { }}
        />
      </div>
    </>
  );
}
